module.exports = __webpack_public_path__ + "img/valvFriction.a02d3e0c.jpg";